<template>
<div class="page-content">
  <h1 class="page-title">{{ $locale("cinemaWebsite.websiteSetting.formItem.websiteInformation") }}</h1>
  <el-form
    class="egl-elm egl-detail"
    :model="websiteGuideSettingInfo"
    label-position="top"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item
          :label="$locale('cinemaWebsite.websiteInformation.formItem.favicon')"
          prop="favicon"
          class="upload"
        >
          <UploadContainer
            :type="'B'"
            :placeholder="$locale('cinemaWebsite.websiteInformation.formItem.favicon.placeholder')"
            :imageList="[websiteGuideSettingInfo.favicon]"
            @onSuccess="({response}) => uploadSuccess(response)"
            @onDelete="deleteImg"
          ></UploadContainer>
        </el-form-item>
      </el-col>
    </el-row>
     <el-row>
      <el-col :span="12">
        <el-form-item
          :label="$locale('cinemaWebsite.websiteInformation.formItem.metadata')"
          prop="metadata"
        >
          <el-input
            type="textarea"
            :rows="5"
            :placeholder="$locale('cinemaWebsite.websiteInformation.formItem.metadata.placeholder')"
            v-model="websiteGuideSettingInfo.metadata" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row>
    <el-col :span="24" style="margin-top:20px;text-indent: 550px;">
      <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
    </el-col>
  </el-row>
</div>
</template>
<script>
import UploadContainer from "@/components/common/UploadContainer";
import { getWebsiteSettingGuideService, updateWebsiteSettingGuideService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      websiteGuideSettingInfo: {
        favicon: "",
        metadata: "",
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    uploadSuccess(res) {
      if (res.success) {
        this.websiteGuideSettingInfo = { ...this.websiteGuideSettingInfo, favicon: res.data };
      }
    },
    deleteImg() {
      this.websiteGuideSettingInfo = { ...this.websiteGuideSettingInfo, favicon: "" };
    },
    getList() {
      // Object.keys(this.websiteGuideSettingInfo).forEach(key => {
      //   this.websiteGuideSettingInfo[key] = "";
      // });
      getWebsiteSettingGuideService({
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        this.websiteGuideSettingInfo = res.data;
      });
    },
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText
      });
    },
    save_fn() {
      try {
        if (JSON.parse(this.websiteGuideSettingInfo.metadata)) {
          const requestParam = {
            ...this.websiteGuideSettingInfo,
            cinemaId: window.localStorage.getItem("cinemaId"),
          };
          updateWebsiteSettingGuideService(requestParam).then(res => {
            this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
          });
        }
      }catch(e) {
        console.log(e);
        this.$alert("メタデータ無効です", {
          lockScroll: false
        });
      }
    }
  },
  components: {
    UploadContainer
  }
};
</script>